<template>
  <div>
    <el-button 
      v-limit="'SYS_MENU_INTRODUCTION_UPDATE'" 
      v-if="showSave" 
      type="primary" 
      style="height: 32px;margin-right: 10px;" 
      @click="handleShow">{{ title }}</el-button>
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      width="80%"
    >
      <editor v-model="content"/>
      <div
        slot="footer"
        class="dialog-footer g-flex g-flex-fe"
      >
        <el-button @click="handleClose">取消</el-button>
        <el-button
          type="primary"
          @click="hanldeSure"
        >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import Editor from '../editor/index';

  export default {
    name: "rich-text",
    components: {
      editor: Editor
    },
    data: () => {
      return {
        title: "产品大佬存档",
        content: "",
        dialogVisible: false
      };
    },
    computed: {
      showSave() {
        return [
          "/base-info/investment-manage", // 基本信息-招商列表
          "/base-info/agent-user-manage", // 基本信息-代理商管理
          "/base-info/self-agent-user-manage", // 基本信息-个人招商管理
          "/data-user", // 数据买点-用户统计
          "/data-agent" // 代理商统计
        ].indexOf(this.$route.fullPath) == -1;
      }
    },
    watch: {
      content(v) {
        console.log(v);
      }
    },
    mounted() {
    },
    methods: {
      handleClose() {
        this.dialogVisible = false;
      },
      hanldeSure() {
        this.$axios.post("/sys/menu/introduction/update.htm", {
          url: this.$route.fullPath,
          introduction: this.content
        }).then(() => {
          this.dialogVisible = false;
        });
      },
      handleShow() {
        this.$axios.post("/sys/menu/introduction/detail.htm", {
          url: this.$route.fullPath
        }).then(req => {
          this.dialogVisible = true;
          if (req.data) {
            this.content = req.data.introduction;
          }
        });
      }
    },
  };
</script>
<style lang="scss" scoped>
/deep/ .el-dialog__body{
  padding: 0 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/rich-text/index.vue